import styles from '../../atendimento-video/components/styles/AgoraVideoContainer.module.css'
import { ID_MINI_PLAYER } from './_models'
import { ClassesDoPlayer, regrasSomenteVideo } from './regrasSomenteVideo'

/** Nomes reais (com hash) das classes do player. `recordingBadge` é `undefined` até a LO-1300 entrar. */
const CLASSES_DO_PLAYER: ClassesDoPlayer = {
  videoContainer: styles.videoContainer,
  remoteUser: styles.remoteUser,
  waitingOverlay: styles.waitingOverlay,
  localPreview: styles.localPreview,
  localOff: styles.localOff,
  localOffIcon: styles.localOffIcon,
  recordingBadge: styles.recordingBadge,
}

/**
 * Proporção (largura/altura) do vídeo do paciente já carregado, ou `undefined` se ainda não houver imagem.
 * Busca dentro do card remoto: a miniatura do próprio médico também é um `<video>`.
 */
export const proporcaoDoVideoDoPaciente = (no: HTMLElement): number | undefined => {
  const video = Array.from(no.getElementsByClassName(CLASSES_DO_PLAYER.remoteUser))
    .flatMap((card) => Array.from(card.getElementsByTagName('video')))
    .find(({ videoWidth, videoHeight }) => videoWidth > 0 && videoHeight > 0)
  return video && video.videoWidth / video.videoHeight
}

export const REGRAS_PIP = regrasSomenteVideo(CLASSES_DO_PLAYER, 'body', { miniaturaDoMedico: true })

export const REGRAS_MINI_PLAYER = regrasSomenteVideo(CLASSES_DO_PLAYER, `#${ID_MINI_PLAYER}`)

/**
 * Enquanto o mini-player fixo estiver visível, reserva sua altura no fim da página (inclusive depois do
 * rodapé do tema) e no scroll de foco por Tab, para que ele nunca cubra por inteiro um elemento focado
 * (WCAG 2.2 SC 2.4.11). Mesma exceção consciente das regras "só vídeo": CSS de runtime, sem arquivo novo.
 * 260px ≈ barra "Voltar" + área de vídeo `h-md-175px` + margem `m-md-5`.
 */
export const REGRAS_RESERVA_MINI_PLAYER =
  'html { scroll-padding-bottom: 260px; } body { padding-bottom: 260px; }'
